module.exports = __webpack_public_path__ + "img/worker.52b2df87.svg";